import React from "react";

export default function IconCaution(props) {
  const { size = 20, currentColor = false, ...rest } = props;

  return (
    <svg width={size} height={size} style={{ minWidth: size, ...rest.style }} viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="caution_google">
        <path
          id="Vector"
          d="M0.833313 18.3335L9.99998 2.50012L19.1666 18.3335H0.833313ZM9.99998 15.8335C10.2361 15.8335 10.434 15.7536 10.5937 15.5939C10.7535 15.4342 10.8333 15.2362 10.8333 15.0001C10.8333 14.764 10.7535 14.5661 10.5937 14.4064C10.434 14.2467 10.2361 14.1668 9.99998 14.1668C9.76387 14.1668 9.56595 14.2467 9.40623 14.4064C9.24651 14.5661 9.16665 14.764 9.16665 15.0001C9.16665 15.2362 9.24651 15.4342 9.40623 15.5939C9.56595 15.7536 9.76387 15.8335 9.99998 15.8335ZM9.16665 13.3335H10.8333V9.16679H9.16665V13.3335Z"
          fill={currentColor ? "currentColor" : "var(--sentiment-text-notice)"}
        />
      </g>
    </svg>
  );
}
